import {gsap} from "gsap";
import {ScrollTrigger} from "gsap/ScrollTrigger";
import {MotionPathPlugin} from "gsap/MotionPathPlugin";

window.addEventListener("DOMContentLoaded", () => {
    gsap.registerPlugin(ScrollTrigger, MotionPathPlugin);

    const container = document.querySelector('.ball-container');
    const ball = document.querySelector('#ball');

    if (container && ball) {
        container.left = 0;
        container.top = 0;
        container.right = container.offsetWidth;
        container.bottom = container.offsetHeight;

        ball.width = ball.offsetWidth;
        ball.height = ball.offsetHeight;

        ball.vel = {x: 10, y: -5};
        ball.pos = {x: container.right / 2, y: container.bottom / 2};
        ball.bounce = -0.68;
        ball.gravity = 0.19;
        ball.friction = {x: 0.004, y: 0.005};

        function calcPhysics() {
            ball.vel.y += ball.gravity;

            let isBounce = false;

            if (ball.pos.x + ball.width / 2 > container.right) {
                ball.pos.x = container.right - ball.width / 2;
                ball.vel.x *= ball.bounce;
                isBounce = true;
            } else if (ball.pos.x - ball.width / 2 < container.left) {
                ball.pos.x = container.left + ball.width / 2;
                ball.vel.x *= ball.bounce;
                isBounce = true;
            }

            if (ball.pos.y + ball.height / 2 > container.bottom) {
                ball.pos.y = container.bottom - ball.height / 2;
                ball.vel.y *= ball.bounce;
                isBounce = true;
            } else if (ball.pos.y - ball.height / 2 < container.top) {
                ball.pos.y = container.top + ball.height / 2;
                ball.vel.y *= ball.bounce;
                isBounce = true;
            }

            if (ball.vel.x >= 0) {
                ball.vel.x -= ball.friction.x;
            } else if (ball.vel.x <= 0) {
                ball.vel.x += ball.friction.x;
            }

            if (ball.vel.y >= 0) {
                ball.vel.y -= ball.friction.y;
            } else if (ball.vel.y <= 0) {
                ball.vel.y += ball.friction.y;
            }

            ball.pos.x += ball.vel.x;
            ball.pos.y += ball.vel.y;
        }

        function setPos(pos) {
            ball.style.left = `${pos.x}px`;
            ball.style.top = `${pos.y}px`;
        }

        function startAnimation() {
            function update() {
                calcPhysics();
                setPos(ball.pos);

                // consoleElement.querySelector('.velocity').innerHTML = `Velocity: <br> x: ${ball.vel.x}</br> y: ${ball.vel.y}`;
                // consoleElement.querySelector('.position').innerHTML = `Position: <br> x: ${Math.round(ball.pos.x)}</br> y: ${Math.round(ball.pos.y)}`;

                requestAnimationFrame(update);
            }

            update();
        }

        function stopAnimation() {
            ball.vel.x = 0;
            ball.vel.y = 0;
            cancelAnimationFrame(stopAnimation);
        }

        function bounceAnimation() {
            if (ball.vel.x > 0) {
                ball.vel.x += 0.5;
            } else if (ball.vel.x < 0) {
                ball.vel.x -= 0.5;
            } else {
                ball.vel.x = 1.5;
            }

            if (ball.vel.y > 0) {
                ball.vel.y += 2;
            } else if (ball.vel.y < 0) {
                ball.vel.y -= 2;
            }
        }

        ScrollTrigger.create({
            trigger: container,
            start: "top center",
            end: "bottom center",
            scrub: true,
            markers: false,
            onEnter: () => {
                startAnimation();
            },
            onUpdate: () => {
                bounceAnimation();
            },
            onLeave: () => {
                stopAnimation();
            }
        });
    }
});
